import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRoles } from '~entities/users';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { queryClient } from '~app/query-client';

import { AuditLogsPage } from '~features/audit-logs';
import { getAuditResourcesOptions } from '~features/audit-logs/api/get-audit-resources';
import { getAuditEventsOptions } from '~features/audit-logs/api/get-audit-events';
import { getAllUsersOptions } from '~entities/users/api/get-all-users';

function RouteComponent() {
  return <AuditLogsPage />;
}

export const Route = createFileRoute('/_auth/_layout/audit-logs')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }

    await Promise.all([
      queryClient.ensureQueryData(getAuditResourcesOptions()),
      queryClient.ensureQueryData(getAuditEventsOptions()),
      queryClient.ensureQueryData(getAllUsersOptions())
    ]);

    return {
      maxAge: 5 * 60 * 1000, // Preloaded data stays valid for 5 minutes
    };
  },
  component: RouteComponent,
});

